import React from "react";
import "./Connectors.css";
const Connectors = ({
  connectors_list,
  updateSelectedConnector,
  selectedConnector,
}) => {
  return (
    <div>
      <nav class="navbar navbar-expand-sm bg-light my-0 py-0 px-2 border">
        <div class="container-fluid">
          <span class="navbar-brand fs-6 fs-sm-3 mx-1 py-0" href="#">
            Connector:
          </span>
          <ul className="nav nav-pills me-auto m-0">
            {connectors_list.map((connector) => (
              <li className="nav-item m-0 p-0 ">
                <a
                  className={
                    selectedConnector &&
                    (connector.id === selectedConnector.id
                      ? "nav-link active py-1 py-md-2 px-3 px-sm-4 px-md-3"
                      : "nav-link py-1 py-md-2 px-3 px-sm-4 px-md-3")
                  }
                  aria-current={
                    selectedConnector &&
                    (connector.id === selectedConnector.id ? "true" : "false")
                  }
                  key={connector.id}
                  onClick={() => {
                    updateSelectedConnector(connector);
                  }}
                >
                  {connector.name_short}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Connectors;
